<!-- @format -->
<template>
    <svg
        class="l6-back-svg"
        :style="{
            '--l6-back-svg-color': color,
            '--l6-back-svg-size': size,
        }"
        xmlns="http://www.w3.org/2000/svg"
        width="22.77"
        height="17.877"
        viewBox="0 0 22.77 17.877"
    >
        <path
            class="a"
            d="M656.3,713.6a2.516,2.516,0,0,1-2.518,2.518H642.034l2.492,2.485a2.307,2.307,0,0,1-3.266,3.26l-7.365-7.365a1.249,1.249,0,0,1,0-1.757l7.411-7.411a2.309,2.309,0,0,1,3.26,0,2.309,2.309,0,0,1,.007,3.26l-2.492,2.486h11.705A2.521,2.521,0,0,1,656.3,713.6Z"
            transform="translate(-633.533 -704.655)"
        />
    </svg>
</template>

<script>
export default {
    name: 'l6-back-svg',

    props: {
        color: {
            type: String,
            default: 'var(--neutral-darkgray)',
        },

        size: {
            type: String,
            default: 'initial',
        },
    },
};
</script>

<style>
.l6-back-svg {
    width: var(--l6-back-svg-size);
}

.l6-back-svg .a {
    fill: var(--l6-back-svg-color) /*svg theme update */;
}
</style>
